import React from "react";
import { Link } from "react-router-dom";
import { NAV, HERO, RTL } from "@/content/site";

const SiteFooter = () => (
    <footer data-testid="site-footer" className="bg-[#0A1812] border-t border-[#1B3025]">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-16 flex flex-col md:flex-row md:items-start md:justify-between gap-10">
            <div>
                <p className="font-sans text-[10px] uppercase tracking-[0.32em] text-[#C7A659]">{HERO.signature.join(" · ")}</p>
                <p className="mt-4 font-sans font-light text-[12.5px] leading-[1.7] text-[#7E8978] max-w-sm">{HERO.title}.</p>
            </div>
            <nav className="flex flex-wrap gap-x-7 gap-y-3" aria-label="Rodapé">
                {NAV.filter((n) => !n.radar).map((n) => (
                    <Link key={n.to} to={n.to} className="font-sans font-light text-[12px] text-[#B0B6A6] hover:text-[#F2EFE5] transition-colors">
                        {n.label}
                    </Link>
                ))}
            </nav>
        </div>
        <div className="max-w-6xl mx-auto px-6 md:px-10 pb-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 border-t border-[#1B3025]/60 pt-6">
            <p className="font-sans font-light text-[10.5px] text-[#5A6859]">
                © {new Date().getFullYear()} raquellauria.com · Imagens: Unsplash (licença gratuita) e geradas por IA
            </p>
            <a href={RTL.url} target="_blank" rel="noopener noreferrer" data-testid="footer-rtl-link" className="font-sans font-light text-[10.5px] text-[#7E8978] hover:text-[#F2EFE5] transition-colors">
                {RTL.eyebrow} · {RTL.label} ↗
            </a>
        </div>
    </footer>
);

export default SiteFooter;
